// extracted by mini-css-extract-plugin
module.exports = {"tabList":"ProductTabs_tabList__jGhNH","label":"ProductTabs_label__ncprC","panel":"ProductTabs_panel__Ulvk5"};